import React from 'react';

function TecladoNumerico({ onNumberClick, onBackspace, onConfirm, dniValue }) {
  const numeros = [1, 2, 3, 4, 5, 6, 7, 8, 9];

  return (
    <div className="teclado-numerico">
      {numeros.map((num) => (
        <button
          key={num}
          className="tecla"
          onClick={() => onNumberClick(num)}
        >
          {num}
        </button>
      ))}
      <button className="tecla tecla-borrar" onClick={onBackspace}>
        ←
      </button>
      <button className="tecla" onClick={() => onNumberClick(0)}>
        0
      </button>
      <button
        className="tecla tecla-confirmar"
        onClick={onConfirm}
        disabled={!dniValue || dniValue.length < 6}
      >
        ✓
      </button>
    </div>
  );
}

export default TecladoNumerico;
